import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gare-crittografiche',
  templateUrl: './gare-crittografiche.component.html',
  styleUrls: ['./gare-crittografiche.component.css']
})
export class GareCrittograficheComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
